'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _form = require('../lib/form');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var label = _ref.label,
      type = _ref.type,
      touched = _ref.touched,
      invalid = _ref.invalid,
      readOnly = _ref.readOnly,
      styles = _ref.styles;
  var colors = _ref2.colors,
      fonts = _ref2.fonts,
      measures = _ref2.measures,
      radiuses = _ref2.radiuses,
      rhythm = _ref2.rhythm,
      scale = _ref2.scale,
      treatments = _ref2.treatments;

  var checkbox = (0, _form.isBoolean)(type);
  var textarea = type === 'textarea';
  var isInvalid = touched && invalid;

  var defaultStyles = {
    root: {
      display: 'block',
      position: 'relative',
      paddingLeft: checkbox ? rhythm(1) : '0',
      fontFamily: fonts.body,
      textAlign: 'left',
      marginBottom: rhythm(1)
    },

    field: checkbox ? {
      position: 'absolute',
      top: rhythm(0.125),
      left: 0
    } : _extends({
      display: 'block',
      width: '100%',
      textAlign: 'left',
      backgroundColor: colors.light,
      color: readOnly ? colors.lightGrey : colors.dark,
      padding: rhythm([0.125, 0.333]),
      height: textarea ? 'auto' : rhythm(1.666),
      minHeight: textarea && rhythm(4),
      maxHeight: textarea && rhythm(10),
      border: 'thin solid ' + (isInvalid ? colors.danger : colors.lightGrey),
      boxShadow: isInvalid ? '0 0 5px ' + colors.danger : 'none',
      borderRadius: rhythm(radiuses.small)
    }, treatments.input, {

      '&:focus': {
        borderColor: isInvalid ? colors.danger : colors.secondary,
        boxShadow: '0 0 5px ' + (isInvalid ? colors.danger : colors.secondary)
      }
    }),

    status: {
      position: 'absolute',
      top: label ? rhythm(1.633) : rhythm(0.5),
      right: rhythm(0.5),
      pointerEvents: 'none'
    }
  };

  return (0, _merge2.default)(defaultStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/input-field/styles.js
// module id = 847
// module chunks = 0